// extracted by mini-css-extract-plugin
module.exports = {"container":"__404_container__MNLb7","wrapper":"__404_wrapper__kSYtQ","text":"__404_text__rtCon","title":"__404_title__oCtRk","link":"__404_link__G1nvY"};